$(window).on('cc-variant-updated', (variant, product) => {
  let sectionId = document.querySelector('[data-section-id]').dataset.sectionId || null;
  let productUrl = document.querySelector('[data-product-url]').dataset.productUrl || null;
  let currentVariantId = Number.parseInt(document.querySelector('[data-current-variant-id]').dataset.currentVariantId) || null;
  let requestedVariantId = product.variant.id || null;

  if (sectionId && productUrl && currentVariantId && requestedVariantId && currentVariantId !== requestedVariantId) {
    fetch(`${productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.getElementById(`VariantMetafields-${sectionId}`);
        const target = document.getElementById(`VariantMetafields-${sectionId}`);
        if (source && target) {
          target.innerHTML = source.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});
